<div class="grid-container">
  <ch-contract-banner [contract]="contract$ | async"> </ch-contract-banner>
  <div class="contract-nav">
    <ch-side-nav [menuItems]="menuItems"></ch-side-nav>
  </div>
  <div class="contract-body">
    <router-outlet></router-outlet>
  </div>
</div>
